import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateInput } from 'rsuite';
import '../css/AdminPanel.css';
import './css/AdminPersonForm.css';
import {
  onlyLatLetters,
  exchangeRateValidation,
} from '../../../Utils/ValidationUtil';
import {
  MALE_SEX,
  FEMALE_SEX,
  DATE_PH,
} from '../../../Utils/Constants/CheckoutConstants';
import { SEX_NOT_SET } from '../../../Utils/Constants/AdminConstants';
import { ReactComponent as GrayCalendar } from '../../../images/gray-calendar-r.svg';

// checkout saves dates as 15-07-1990
const SAVED_DATE_FORMAT = 'DD-MM-YYYY';

const parseSavedDate = (value) => {
  const date = moment(
    value,
    [SAVED_DATE_FORMAT, 'DD/MM/YYYY', 'DD.MM.YYYY'],
    true,
  );

  return date.isValid() ? date.toDate() : null;
};

function AdminPersonForm(props) {
  const { title, fields, person, handleChange, actions } = props;
  const getInputId = (field) =>
    `apf-${title.replace(/\s/g, '-')}-${field.key}`;

  const handleValueChange = (field, value) => {
    // passport names are latin capitals, as on checkout
    if (field.type === 'upper') {
      if (onlyLatLetters(value)) {
        handleChange(field.key, value.toUpperCase());
      }

      return;
    }

    // prices: digits and a dot
    if (field.type === 'number') {
      if (exchangeRateValidation(value)) {
        handleChange(field.key, value);
      }

      return;
    }

    handleChange(field.key, value);
  };

  const handleDateChange = (field, date) => {
    const isValidDate = date && !Number.isNaN(date.getTime());

    handleChange(
      field.key,
      isValidDate ? moment(date).format(SAVED_DATE_FORMAT) : '',
    );
  };

  const renderInput = (field) => {
    const value = person[field.key] || '';

    // the same date input as on checkout
    if (field.type === 'date') {
      return (
        <div className="apf_date">
          <DateInput
            id={getInputId(field)}
            format={DATE_PH}
            placeholder={DATE_PH}
            defaultValue={parseSavedDate(value)}
            className="ap_text_input apf_input"
            onChange={(date) => handleDateChange(field, date)}
          />
          <GrayCalendar className="apf_date_ico" />
        </div>
      );
    }

    if (field.type === 'sex') {
      return (
        <select
          id={getInputId(field)}
          className="ap_text_input apf_input"
          value={value}
          onChange={(e) => handleValueChange(field, e.target.value)}
        >
          <option value="">{SEX_NOT_SET}</option>
          <option value="male">{MALE_SEX}</option>
          <option value="female">{FEMALE_SEX}</option>
        </select>
      );
    }

    if (field.type === 'select') {
      return (
        <select
          id={getInputId(field)}
          className="ap_text_input apf_input"
          value={value}
          onChange={(e) => handleValueChange(field, e.target.value)}
        >
          {field.options.map((option) => (
            <option
              key={`apf-option-${field.key}-${option.value}`}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </select>
      );
    }

    return (
      <input
        id={getInputId(field)}
        className="ap_text_input apf_input"
        type="text"
        value={value}
        onChange={(e) => handleValueChange(field, e.target.value)}
      />
    );
  };

  return (
    <div className="apf_card">
      <div className="apf_head">
        <div className="bm_text_18">{title}</div>
        {actions}
      </div>
      <div className="apf_fields">
        {fields.map((field) => (
          <label
            key={`apf-field-${field.key}`}
            className="apf_field"
            htmlFor={getInputId(field)}
          >
            <span className="gr_text_13">{field.label}</span>
            {renderInput(field)}
          </label>
        ))}
      </div>
    </div>
  );
}

AdminPersonForm.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.instanceOf(Array).isRequired,
  person: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  actions: PropTypes.node,
};

AdminPersonForm.defaultProps = {
  actions: null,
};

export default AdminPersonForm;
